import { Link, routes } from '@redwoodjs/router'
import { Toaster } from '@redwoodjs/web/toast'

type MuscleLayoutProps = {
  children: React.ReactNode
}

const MusclesLayout = ({ children }: MuscleLayoutProps) => {
  return (
    <div className="rw-scaffold">
      <Toaster />
      <header className="rw-header">
        <h1 className="rw-heading rw-heading-primary">
          <Link
            to={routes.muscles()}
            className="rw-link"
          >
            Muscles
          </Link>
        </h1>
        <Link
          to={routes.newMuscle()}
          className="rw-button rw-button-green"
        >
          <div className="rw-button-icon">+</div> New Muscle
        </Link>
      </header>
      <main className="rw-main">{children}</main>
    </div>
  )
}

export default MusclesLayout
